export const estimatedBlocksIntervalRewards = async (
  fromBlock: number,
  toBlock: number,
  currentStrategy: any,
) => {
  let result = estimatedBlocksIntervalStrategyRewards(fromBlock, toBlock, currentStrategy);
  return result;
};

export const estimatedBlocksIntervalStrategyRewards = (
  fromBlock: number,
  toBlock: number,
  strategy: number[],
) => {
  const strategyFromBlock = Math.max(fromBlock, strategy[2]);
  const strategyToBlock = Math.max(toBlock, strategy[0]);

  if (strategyToBlock <= strategyFromBlock) {
    return '0';
  }

  return strategy[1] * (strategyToBlock - strategyFromBlock);
};
